import React from "react";
import PropTypes from "prop-types";
import styles from "./Button.module.css";
import classNames from "classnames";
const CustomButton = ({
	title = "Submit",
	variant = "primary",
	onClick,
	type,
	className,
	disabled,
	style,
}: any) => {
	return (
		<button
			onClick={onClick}
			className={classNames(
				styles.button,
				{
					[styles.buttonPrimary]: variant === "primary",
					[styles.buttonSecondary]: variant === "secondary",
					[styles.error]: variant === "error",
					[styles.disabled]: disabled,
				},
				className
			)}
			type={type}
			disabled={disabled}
			style={style}
		>
			{title}
		</button>
	);
};
CustomButton.propTypes = {
	title: PropTypes.string,
	type: PropTypes.string,
	variant: PropTypes.string,
	className: PropTypes.string,
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
	style: PropTypes.object,
};
export default CustomButton;
